document.addEventListener( 'DOMContentLoaded', function () {
	const banner = document.getElementById( 'app-banner' );
	const DISMISS_KEY = 'appBannerDismissedAt';
	const DISMISS_DURATION_MS = 24 * 60 * 60 * 1000;

	if ( ! banner ) return;

	const root = document.documentElement;
	const isMobileView = window.matchMedia( '(max-width: 767px)' ).matches;

	const applyBannerOffset = () => {
		const bannerHeight = Math.ceil(
			banner.getBoundingClientRect().height || 0
		);
		root.style.setProperty( '--app-banner-height', `${ bannerHeight }px` );
		document.body.classList.add( 'has-app-banner' );
	};

	const clearBannerOffset = () => {
		banner.classList.remove( 'visible' );
		document.body.classList.remove( 'has-app-banner' );
		root.style.removeProperty( '--app-banner-height' );
	};

	const isDismissedInCooldown = () => {
		const dismissedAtRaw = localStorage.getItem( DISMISS_KEY );
		if ( ! dismissedAtRaw ) return false;

		const dismissedAt = Number( dismissedAtRaw );
		if ( Number.isNaN( dismissedAt ) ) {
			localStorage.removeItem( DISMISS_KEY );
			return false;
		}

		return Date.now() - dismissedAt < DISMISS_DURATION_MS;
	};

	if ( ! isMobileView || isDismissedInCooldown() ) {
		clearBannerOffset();
		return;
	}

	const closeBtn = document.getElementById( 'close-banner' );
	const appLink = document.getElementById( 'app-link' );
	const subtitleEl = document.getElementById( 'app-banner-subtitle' );
	const ua = navigator.userAgent || navigator.vendor || window.opera;
	const isAndroid = /android/i.test( ua );
	const isiOS = /iPhone|iPad|iPod/i.test( ua );

	const ANDROID_INTENT_URL =
		'intent://details?id=org.pro14rugby.app#Intent;scheme=market;package=com.android.vending;end';

	const IOS_STORE_URL =
		'itms-apps://apps.apple.com/in/app/united-rugby-championship/id1436694463';

	banner.classList.add( 'visible' );
	applyBannerOffset();

	if ( isAndroid ) {
		subtitleEl.innerHTML =
			'Your official home for all things URC!<br>FREE – On Play Store';
		appLink.textContent = 'INSTALL';
		appLink.href = ANDROID_INTENT_URL;
	} else if ( isiOS ) {
		subtitleEl.innerHTML =
			'Your official home for all things URC!<br>FREE – On App Store';
		appLink.textContent = 'INSTALL';
		appLink.href = IOS_STORE_URL;
	} else {
		subtitleEl.innerHTML =
			'Your official home for all things URC!<br>FREE – On App Store & Google Play';
		appLink.textContent = 'INSTALL';
		appLink.href = IOS_STORE_URL;
	}

	if ( closeBtn ) {
		closeBtn.addEventListener( 'click', () => {
			localStorage.setItem( DISMISS_KEY, String( Date.now() ) );
			clearBannerOffset();
		} );
	}
} );
